import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ModalForm from "../views/examples/ModalForm";

export function MyVerticallyCenteredModal(props) {
    const {data, id} = props;
    const [modalData, setModalData] = useState(data);

    useEffect(() => {
        console.log(props, "Props in only modal");
        console.log(data, "Data ");
        if (data) {
            console.log(data[id]);
            setModalData(data[id]);
        }
        return () => {
        };
    }, [data]);

    // let keys = [];
    // let values = [];
    // let obj = [];
    // for (var key in data[0]) {
    //   // keys.push(key);
    //   // values.push(data[0][key])
    //   obj.push({ key: key, value: data[0][key] });
    // }

    //  const url =
    //  const urlRes =  downloadFile(filename);


    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter "
            centered>
            {/* <Modal.Header
        closeButton={<i class="fa fa-window-close" aria-hidden="true"></i>}
      ></Modal.Header> */}
            <Modal.Body style={{
                padding: 0,
                margin: 0,
                overflow: 'hidden',
                border: 'none',
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5
            }}
                        className=""
            >

                <ModalForm modalData={modalData}/>
            </Modal.Body>

            <Modal.Footer className="m-0 pt-0">


                <Button size="sm" onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}
